import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Filter9PlusIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_9_plus"}/>
}
